var CandidateConferenceController = /** @class */ (function () {
    /*@ngInject*/
    function CandidateConferenceController($rootScope, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    CandidateConferenceController.prototype.$onInit = function () {
        this.isLoading = true;
        this.$rootScope.hideNav = true;
        this._getScheduleDetails();
    };
    CandidateConferenceController.prototype._getScheduleDetails = function () {
        var _this = this;
        this.meetingService.getScheduleDetails(this.scheduleId, function (data) {
            _this.scheduleInfo = _this.meetingService.getMassagedMeetingDetails(data);
            if (_this.jobId && _this.jobId == "") {
                _this.jobId = data.jobId;
            }
            _this.isLoading = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    };
    return CandidateConferenceController;
}());
CandidateConferenceController.$inject = ['$rootScope', 'meetingService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './candidate-conference.html';
import * as TEMPLATE from 'raw-loader!./candidate-conference.html';
export var CandidateConferenceComponent = {
    selector: 'candidateConference',
    component: {
        bindings: {
            scheduleId: '@',
            candidateId: '@',
            jobId: '@',
            jobMatchId: '@',
            workflowStep: '@',
            participantType: '@',
            type: '@',
            mode: '@'
        },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/candidateConference/candidateConference/candidate-conference.html',
        controller: CandidateConferenceController
    }
};
//# sourceMappingURL=candidate-conference.component.js.map